export default {
  name: process.env.npm_package_name,
  version: process.env.npm_package_version,
  env: process.env.REACT_APP_ENV || process.env.NODE_ENV,
};
